import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["display"]
    static values = {
        suffix: { type: String, default: "" }
    }

    connect() {
        const input = this.element.tagName === "INPUT" ? this.element : this.element.querySelector('input[type="range"]')
        if (input) {
            this.updateDisplay(input.value)
        }
    }

    update(event) {
        this.updateDisplay(event.target.value)
    }

    updateDisplay(value) {
        if (this.hasDisplayTarget) {
            this.displayTarget.textContent = `${value}${this.suffixValue}`
        }
    }
}
